// components
import Button from '@drivesally/sally-ui/lib/components/Button/Button';
import Select from '@drivesally/sally-ui/lib/components/Select/Select';
import Switch from '@drivesally/sally-ui/lib/components/Switch/Switch';
import Row from '@drivesally/sally-ui/lib/components/Grid/Row/Row';
import Column from '@drivesally/sally-ui/lib/components/Grid/Column/Column';

// propTypes
import PropTypes from 'prop-types';

// react
import React, {Component, Fragment} from 'react';

// A group is added as one action (pick 2+ fields, then commit) rather than
// merging a field into an already-added entry - keeps this simple and avoids
// having to track which existing entry a new field should attach to.
class AddRequirement extends Component {
  static propTypes = {
    options: PropTypes.array,
    onAdd: PropTypes.func,
    onAddGroup: PropTypes.func,
  };

  state = {
    grouping: false,
    pending: [],
  };

  toggleGrouping = (grouping) => this.setState({grouping, pending: []});

  togglePending = (value) => {
    const {pending} = this.state;
    this.setState({
      pending: pending.includes(value)
        ? pending.filter((existing) => existing !== value)
        : [...pending, value],
    });
  };

  addGroup = () => {
    const {pending} = this.state;
    if (pending.length < 2) return;
    this.props.onAddGroup(pending);
    this.setState({pending: [], grouping: false});
  };

  render() {
    const {options, onAdd} = this.props;
    const {grouping, pending} = this.state;

    return (
      <Fragment>
        <Row margin>
          <Column size={3 / 4}>
            {grouping ? (
              <Select
                value={pending}
                options={options}
                onChange={this.togglePending}
                placeholder="Pick 2 or more fields..."
                size="small"
                flat
              />
            ) : (
              <Select
                value=""
                options={options}
                onChange={(selectedAttribute) => onAdd(selectedAttribute)}
                size="small"
                flat
              />
            )}
          </Column>
          <Column size={1 / 4}>
            <Switch value={grouping} onChange={this.toggleGrouping}>
              Group (OR)
            </Switch>
          </Column>
        </Row>
        {grouping && (
          <Row margin>
            <Column>
              <Button
                size="small"
                theme="grey"
                disabled={pending.length < 2}
                onClick={this.addGroup}
              >
                Add Group
              </Button>
            </Column>
          </Row>
        )}
      </Fragment>
    );
  }
}

export default AddRequirement;
